import { Note } from '../../../_service/data.service';
import { MenuItem } from 'primeng/api';

/**
 * Template management logic extracted from HomeComponent.
 * Handles menu item construction and state for template operations.
 */
export class TemplateLogic {
  /**
   * Build template menu items based on loading state and template data
   */
  static buildTemplateMenuItems(
    isLoading: boolean,
    error: string,
    templates: Note[],
    onSelectTemplate: (template: Note) => void,
  ): MenuItem[] {
    const items: MenuItem[] = [
      {
        label: 'Create note from template:',
        disabled: true,
        styleClass: 'text-xs text-surface-500 uppercase tracking-wide',
      },
    ];

    if (isLoading) {
      items.push({
        label: 'Loading templates...',
        disabled: true,
        icon: 'pi pi-spin pi-spinner',
      });
      return items;
    }

    if (error) {
      items.push({
        label: error,
        disabled: true,
        styleClass: 'text-red-500',
      });
      return items;
    }

    if (!templates.length) {
      items.push({
        label: 'No templates found.',
        disabled: true,
      });
      return items;
    }

    items.push(
      ...templates.map((template) => ({
        label: template.templateName || template.Title || 'Untitled template',
        icon: 'pi pi-clone',
        command: () => onSelectTemplate(template),
      })),
    );

    return items;
  }
}
